import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Account, AppConfiguration, WelcomeModalHeader, WelcomeModalStates, WelcomeModalType, useAppSelector, useAppDispatch } from "src/common";
import { MailClient, ProtectAccount, Express } from ".";
import { uiActions } from "src/store";

function AddToMailClient() {
  const is_express = AppConfiguration.buildForExpress();
  const dispatch = useAppDispatch();
  const organization = useAppSelector((state) => state.account.organization);
  const [modal_state, setModalState] = useState<WelcomeModalType>(Account.isShowMUAPrompt(organization) ? WelcomeModalStates.page_one : WelcomeModalStates.page_two);

  // Description: Handle states of modal. If is a close, dismiss the message too
  const handleShowModal = (modal: WelcomeModalType) => {
    modal === WelcomeModalStates.close &&
      dispatch(uiActions.handleMessageDismiss());
    setModalState(modal);
  };

  // Description: Return modal content depending on Build mode and page number
  function ModalContent() {
    return is_express ?
      <Express handleShowModal={handleShowModal} /> :
      modal_state === WelcomeModalStates.page_one ?
        <MailClient handleShowModal={handleShowModal} /> :
        <ProtectAccount handleShowModal={handleShowModal} />;
  }

  // Show Page one only for ORG users
  return <Modal
    size="lg"
    backdrop={is_express ? "static" : true} // Close modal on backdrop click only if not express.
    keyboard={!is_express} // Close modal on escape key only if not express.
    dialogClassName="welcome-modal"
    show={modal_state !== WelcomeModalStates.close}
    onHide={() => handleShowModal(WelcomeModalStates.close)}
    aria-label={is_express ? WelcomeModalHeader.express : modal_state === WelcomeModalStates.page_one ? WelcomeModalHeader.page_one : WelcomeModalHeader.page_two}
    >
    <Modal.Header>
      <Modal.Title>
        {
          is_express ? WelcomeModalHeader.express :
            modal_state === WelcomeModalStates.page_one ? WelcomeModalHeader.page_one : WelcomeModalHeader.page_two
        }
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <ModalContent />
    </Modal.Body>
  </Modal>;
}

export default React.memo(AddToMailClient);
